import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import { MOCK_STATION_LOGINS } from '../people/peopleMockData';
import { TRAINING_STATUS, filterByTrainingStatus } from '../people/peopleHelpers';
import StationTrainingTable from '../people/StationTrainingTable';
import '../people/PeopleTab.css';

export default function PeopleTab({ date }) {
  const noTraining = useMemo(() => filterByTrainingStatus(MOCK_STATION_LOGINS, TRAINING_STATUS.NONE), []);
  const inProgress = useMemo(() => filterByTrainingStatus(MOCK_STATION_LOGINS, TRAINING_STATUS.IN_PROGRESS), []);

  return (
    <div>
      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: 16 }}>
        <h3 style={{ margin: 0 }}>People Performance</h3>
        <span style={{ fontSize: 13, color: '#6c757d' }}>Date: {date}</span>
      </div>

      <div style={{ display: 'flex', flexDirection: 'column', gap: 24 }}>
        <StationTrainingTable title="Logged In — No Training" countLabel="user(s) logged into a station with no training" records={noTraining} />
        <StationTrainingTable title="Logged In — Training In Progress" countLabel="user(s) logged into a station with training in progress" records={inProgress} />
      </div>
    </div>
  );
}

PeopleTab.propTypes = {
  date: PropTypes.string.isRequired
};
